// Single source of truth for what every session replay vendor must hide; mark
// an element with data-sensitive rather than configuring a vendor separately.
export const SENSITIVE_SELECTOR = "[data-sensitive]";
